"use client";

import { type Locale } from "@/i18n/routing";
import { cn } from "@heroui/theme";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";
import { ReactNode } from "react";
import { PublicFooter } from "./PublicFooter";

interface PublicLayoutShellProps {
  children: ReactNode;
}

export function PublicLayoutShell({ children }: PublicLayoutShellProps) {
  const pathname = usePathname();
  const locale = useLocale() as Locale;
  const isChatRoute =
    !!pathname &&
    (pathname.includes("/chat") || pathname.includes("/keskustelu"));
  // On tournament paths the mobile header is `MobileNav`, not `PublicHeader`.
  // Its rendered height (including iOS safe-area-top) is published to
  // `--mobile-nav-h`; fall back to 98px (row 1 ≈ 52px + row 2 ≈ 46px) plus
  // safe-area before the ResizeObserver fires.
  // Non-tournament mobile uses the shared `MobileHeaderBar` (52px = h-13);
  // add safe-area-top so iOS notch/Dynamic Island doesn't cover the chrome.
  const isTournamentPath = !!pathname && /\/tournaments\/[^/]+/.test(pathname);

  return (
    <>
      <main
        className={cn(
          "relative z-10 mx-auto max-w-[1600px] flex-1 w-full",
          isTournamentPath
            ? "pt-[calc(env(safe-area-inset-top)+var(--mobile-nav-h,98px))] lg:pt-[var(--desktop-nav-h,100px)]"
            : "pt-[calc(env(safe-area-inset-top)+52px)] lg:pt-[76px]",
          !isChatRoute && "mb-16",
        )}
      >
        {children}
      </main>
      {!isChatRoute && <PublicFooter locale={locale} />}
    </>
  );
}
